/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { COLOR, BORDER_RADIUS } from '@ordermentum/ui-static';

export type CallbackSaveValueT = (string, boolean) => any;

type propsT = {
  id: string;
  label: string;
  checked?: boolean;
  saveValue: CallbackSaveValueT;
  required?: boolean;
  disabled?: boolean;
};

const checkboxContainerStyles = css([
  {
    marginBottom: '0.3rem',
  },
]);

const checkboxInputStyles = css({
  height: 'inherit',
  borderRadius: BORDER_RADIUS.MEDIUM,
  border: `1px solid ${COLOR.GRAYISH}`,
  boxShadow: 'none',
  padding: '0 0.5rem',
  marginRight: '0.5rem',
});

const FormCheckbox = ({
  id,
  label,
  required,
  saveValue,
  checked = false,
  disabled = false,
}: propsT) => {
  const handleChange = e => {
    saveValue(id, e.target.checked);
  };

  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <div css={checkboxContainerStyles}>
      <input
        type="checkbox"
        id={`om-form-checkbox-${id}`}
        name={id}
        css={css(checkboxInputStyles)}
        onClick={handleChange}
        checked={checked}
        required={required}
        disabled={disabled}
        onChange={() => {}}
      />
      <label htmlFor={`om-form-checkbox-${id}`}>{label}</label>
    </div>
  );
  /* eslint-enable jsx-a11y/label-has-for */
};

FormCheckbox.defaultProps = {
  required: false,
  checked: false,
  disabled: false,
};

export default FormCheckbox;
